import { useQuery } from "@tanstack/react-query";
import { authorizedAxios } from "@moonscape/shared";
import { useAuth0 } from "@auth0/auth0-react";

export interface LatestTransaction {
  type: string;
  pair: string;
  amount: string | null;
  asset: string | null;
  timestamp: number;
  createdAt: string;
}

interface LatestTransactionsResponse {
  transactions: LatestTransaction[];
  totalImported: number;
}

export const useLatestTransactions = (
  exchangeId: string | undefined,
  enabled: boolean
) => {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery<LatestTransactionsResponse>({
    queryKey: ["latest-transactions", exchangeId],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const { data } = await authorizedAxios(token).get(
        `/trades/latest/${exchangeId}`,
        { params: { limit: 5 } }
      );
      return data;
    },
    enabled: !!exchangeId && enabled,
    refetchInterval: enabled ? 10_000 : false,
    refetchOnWindowFocus: false,
  });
};
